import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import es from 'vuetify/src/locale/es'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({

  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: colors.lightBlue.lighten1,
        secondary: colors.lightBlue.lighten2,
        accent: colors.lightBlue.lighten2
      },
      dark: {
        primary: colors.lightBlue.lighten1,
        accent: colors.lightBlue.lighten3
      }
    }
  },
  lang: {
    locales: { es },
    current: 'es'
  },
  icons: {
    iconfont: 'mdi'
  }
})
